module.exports = __webpack_public_path__ + "img/sunday_times.b52b19a9.svg";